import {PropertiesPane} from '../components/NodePropertiesPane.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import TagSelect from '../../SidePanel/RightPanel/PropertiesControllerTagSelect.jsx'
import Model from './ModelUirule.mjs'
import UiruleType from './UiruleType.jsx'

const PropertiesPaneBatchUirule = (props) => (
    <PropertiesPane
        controllers={
            <>
                <Select
                    options={UiruleType}
                    prop="ruleType"
                />

                <TagSelect prop="ruleKey" />
            </>
        }

        Model={Model}
        {...props}
    />
)

export default PropertiesPaneBatchUirule
